// extracted by mini-css-extract-plugin
export default {"auditNewDetail":"detail_auditNewDetail__HDAoN","iframe":"detail_iframe__1CbQ5"};